import { render, staticRenderFns } from "./QuestionLayoutD.vue?vue&type=template&id=0546cc50&scoped=true&"
import script from "./QuestionLayoutD.vue?vue&type=script&lang=js&"
export * from "./QuestionLayoutD.vue?vue&type=script&lang=js&"
import style0 from "./QuestionLayoutD.vue?vue&type=style&index=0&id=0546cc50&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0546cc50",
  null
  
)

export default component.exports